<!-- Template -->
<ul nz-menu nzMode="horizontal" class="rounded-sm px-4">
  @if (userType === 'SUPER_ADMIN') {
    <li
      nz-menu-item
      routerLink="/dashboard/complaints"
      routerLinkActive="ant-menu-item-selected"
      class="relative"
      #overviewItem="routerLinkActive"
    >
      <span class="menu-text">Overview</span>
      @if (overviewItem.isActive) {
        <span class="active-indicator"></span>
      }
    </li>
  }

  <li
    nz-menu-item
    routerLink="/dashboard/cases"
    routerLinkActive="ant-menu-item-selected"
    #casesItem="routerLinkActive"
  >
    <span class="menu-text">Cases</span>
    @if (casesItem.isActive) {
      <span class="active-indicator"></span>
    }
  </li>

  <li
    nz-menu-item
    routerLink="/dashboard/analytics"
    routerLinkActive="ant-menu-item-selected"
    #analyticsItem="routerLinkActive"
  >
    <span class="menu-text">Analytics</span>
    @if (analyticsItem.isActive) {
      <span class="active-indicator"></span>
    }
  </li>
</ul>
